import { makeRootStyles } from "../theme/styles";

const useStyles = makeRootStyles(
  {
    confirmationHeader: {
      textAlign: "left",
    },
    btnContainer: {
      margin: "1.5rem 0",
    },
    imgContainer: {
      width: "50%",
      maxWidth: "200px",
    },
    alternateEmailForm: {
      maxWidth: "400px",
      margin: "15px 0",
      display: "flex",
      gap: "20px",
    },
  },
  { name: "Confirmation" },
);

export { useStyles };
